module.exports = (__webpack_require__(2))(43);


//////////////////
// WEBPACK FOOTER
// delegated ./src/models/AccessControlledModel.js from dll-reference girder_lib
// module id = 46
// module chunks = 0